<administrasjon-navigasjon aktiv="soek">
<div class="administrasjon-sok-side">

    <administrasjon-sok (navigerTilTreff)="vedNavigerTilTreff($event)"/>

    <main>
        @if (gruppe(); as valgtGruppe) {
            <administrasjon-gruppe [gruppe]="valgtGruppe" [aggregater]="gruppeaggregat()"/>
        } @else if (bruker(); as valgtBruker) {
            <administrasjon-bruker [bruker]="valgtBruker"/>
        } @else if (medlem(); as valgtMedlem) {
            <administrasjon-medlem [medlem]="valgtMedlem"/>
        }
    </main>
</div>
</administrasjon-navigasjon>
